// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__32vQq","title":"Header_title__3339l","login":"Header_login__2J3kH","loading":"Header_loading__2vMwI","loaded":"Header_loaded__J6FNc"};